import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import {
  EffectCoverflow,
  Navigation,
  Autoplay,
  Pagination,
} from "swiper/modules";

const Sec = () => {
  const images = [
    {
      image:
        "https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=1400&auto=format&fit=crop",
      number: "01",
      title: "Maaş necə hesablanır?",
      description:
        "Maaş komandanızın nəticəsinə əsasən hesablanır. siz komandaniza 1 və ya 2 insan dəvət edirsiz bundan sonra siz heckimi dəvət etməsəz belə sizin dəvətliləriniz insan dəvət etdikdə maaş hesablanmaqa başlayır. Maaşı artırmaq istəsəz komandaniza yeni insanlar dəvət edə bilərsiz.",
      stat: "KOMANDA",
      statText: "Əsas amil",
    },

    {
      image:
        "https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1400&auto=format&fit=crop",
      number: "02",
      title: "Tək qol maaşı",
      description:
        "Siz əgər 1 insan dəvət etsəz tək qol maaşı alacaqsız. Tək qol maaş hesablanması sizinlə birlikde komandanızda 10 insan olduqda hesablanmağa başlayır.",
      stat: "TƏK QOL",
      statText: "Bir tərəf",
    },

    {
      image:
        "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1400&auto=format&fit=crop",
      number: "03",
      title: "Cüt qol maaşı",
      description:
        "Həm sağ, həm də sol tərəfdə komandanız olduqda cüt qol maaşı tətbiq olunur. Bunun üçün hər iki tərəfdə komanda yaratmaq vacibdir. Komandanızda sizinlə birlikdə 6 insan olduqda cüt qol maaş hesablanması başlayır.",
      stat: "SAĞ + SOL",
      statText: "İki tərəf",
    },

    {
      image:
        "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=1400&auto=format&fit=crop",
      number: "04",
      title: "Hər iki tərəfi böyüt",
      description:
        "Sağ və sol tərəfdə komandanı birlikdə inkişaf etdirmək qazanc sistemində daha əlverişli nəticələr əldə etməyə kömək edə bilər. Yəni sizin hər iki dəvlətniz aktiv olmalidir sağ qolda 5 , sol qolda 50 insan olduqda tarazlıq pozulur ve maaş hesablanmasina tesir gösdərir.",
      stat: "SAĞ + SOL",
      statText: "Balanslı inkişaf",
    },

    {
      image:
        "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=1400&auto=format&fit=crop",
      number: "05",
      title: "Komandan böyüdükcə",
      description:
        "Komandanızda insanların sayı və ümumi nəticə artdıqca sistemdə daha yüksək səviyyələrə çatmaq imkanınız yaranır.",
      stat: "10 → 25 → 50",
      statText: "Komanda böyüməsi",
    },

    {
      image:
        "https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=1400&auto=format&fit=crop",
      number: "06",
      title: "Daha böyük komanda",
      description:
        "Kiçik komandadan başlayaraq davamlı şəkildə yeni insanlar əlavə edin. Komandanız böyüdükcə qazanc imkanlarınız da genişlənir.",
      stat: "100+",
      statText: "Böyük komanda",
    },

    {
      image:
        "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1400&auto=format&fit=crop",
      number: "07",
      title: "Rütbəni yüksəlt",
      description:
        "Komanda nəticələriniz artdıqca sistemdə daha yüksək rütbələr əldə edə bilərsiniz. Məsləhətçidən başlayaraq Menecer, Lider, Direktor və daha yüksək səviyyələrə yüksəlmək mümkündür.",
      stat: "YÜKSƏLİŞ",
      statText: "Daha yüksək rütbə",
    },

    {
      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=1400&auto=format&fit=crop",
      number: "08",
      title: "Davamlı inkişaf et",
      description:
        "Daha çox qazanmaq istəyirsinizsə, komandanızı böyüdün, hər iki tərəfdə aktivlik yaradın və komandanızın davamlı inkişafına diqqət edin.",
      stat: "SAĞ + SOL",
      statText: "Güclü komanda",
    },
  ];

  const sidePhotos = [
    {
      image:
        "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1200&auto=format&fit=crop",
      title: "Birlikdə böyüyək",
      text:
        "Komandanıza yeni insanlar qoşulduqca birlikdə daha böyük nəticələrə doğru irəliləyin.",
    },

    {
      image:
        "https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1200&auto=format&fit=crop",
      title: "Sağ və sol tərəf",
      text:
        "Hər iki tərəfdə komanda qurmaq və onları birlikdə inkişaf etdirmək vacibdir.",
    },
  ];

  return (
    <section className="relative overflow-hidden bg-gray-50 px-4 py-16 transition-colors duration-500 dark:bg-[#050505] md:px-12">
      {/* Arxa fon işıqları */}
      <div className="pointer-events-none absolute left-[-150px] top-[20%] h-[350px] w-[350px] rounded-full bg-blue-600/10 blur-[120px]" />

      <div className="pointer-events-none absolute bottom-[-150px] right-[-100px] h-[400px] w-[400px] rounded-full bg-cyan-500/10 blur-[130px]" />

      {/* BAŞLIQ */}
      <div className="relative z-10 mb-14 text-center">
        <span className="mb-3 inline-block rounded-full border border-blue-500/30 bg-blue-500/10 px-4 py-1 text-xs font-bold tracking-[0.25em] text-blue-600 dark:text-blue-400">
          ARTİM QAZANC SİSTEMİ
        </span>

        <h2 className="text-4xl font-black uppercase italic tracking-tighter text-gray-900 dark:text-white md:text-6xl">
          Artim{" "}
          <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent">
            Qazanc Vizyonu
          </span>
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-gray-600 dark:text-gray-400 md:text-base">
          Komandanı böyüt, sağ və sol tərəfdə inkişaf yarat və daha yüksək
          səviyyələrə doğru irəlilə.
        </p>

        <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-blue-600 shadow-[0_0_20px_rgba(37,99,235,0.7)]" />
      </div>

      {/* ƏSAS HİSSƏ */}
      <div className="relative z-10 mx-auto flex max-w-7xl flex-wrap gap-10 lg:flex-nowrap">
        {/* SWIPER */}
        <div className="order-2 w-full lg:order-1 lg:w-[68%]">
          <Swiper
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView="auto"
            coverflowEffect={{
              rotate: 28,
              stretch: 0,
              depth: 180,
              modifier: 1,
              slideShadows: true,
            }}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            speed={1000}
            loop={true}
            navigation={true}
            pagination={{
              clickable: true,
            }}
            modules={[
              EffectCoverflow,
              Autoplay,
              Navigation,
              Pagination,
            ]}
            className="artim-swiper h-[520px] md:h-[600px]"
          >
            {images.map((item, index) => (
              <SwiperSlide
                key={index}
                className="max-w-[310px] md:max-w-[470px]"
              >
                <div className="group relative h-full w-full overflow-hidden rounded-[28px] border border-white/10 bg-black shadow-2xl">
                  {/* Şəkil */}
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                  />

                  {/* Qaranlıq örtük */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/45 to-transparent" />

                  <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 via-transparent to-cyan-400/10" />

                  {/* Nömrə */}
                  <div className="absolute left-5 top-5 flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-black/40 text-sm font-black text-white backdrop-blur-md">
                    {item.number}
                  </div>

                  {/* ARTİM */}
                  <div className="absolute right-5 top-5 rounded-full border border-white/20 bg-black/40 px-3 py-1 text-[10px] font-bold tracking-[0.2em] text-white backdrop-blur-md">
                    ARTİM
                  </div>

                  {/* MƏTN */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <div className="mb-4 flex items-end justify-between gap-4">
                      <div>
                        <h3 className="text-2xl font-black uppercase leading-tight text-white md:text-3xl">
                          {item.title}
                        </h3>

                        <div className="mt-2 h-1 w-12 rounded-full bg-blue-500" />
                      </div>

                      {/* Statistik kart */}
                      <div className="shrink-0 rounded-2xl border border-white/20 bg-white/10 px-4 py-3 text-right backdrop-blur-xl">
                        <div className="text-lg font-black text-white">
                          {item.stat}
                        </div>

                        <div className="text-[9px] font-semibold uppercase tracking-wider text-gray-300">
                          {item.statText}
                        </div>
                      </div>
                    </div>

                    <p className="max-w-xl text-sm leading-6 text-gray-200 md:text-base">
                      {item.description}
                    </p>

                    {/* Proqress */}
                    <div className="mt-5 h-1 overflow-hidden rounded-full bg-white/20">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-blue-500 to-cyan-400"
                        style={{
                          width: `${((index + 1) / images.length) * 100}%`,
                        }}
                      />
                    </div>

                    <div className="mt-2 flex justify-between text-[9px] font-bold uppercase tracking-widest text-gray-400">
                      <span>Artim qazanc sistemi</span>

                      <span>
                        {String(index + 1).padStart(2, "0")} /{" "}
                        {String(images.length).padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* SAĞ KARTLAR */}
        <div className="order-1 flex w-full flex-col gap-6 lg:order-2 lg:w-[32%]">
          {sidePhotos.map((item, index) => (
            <div
              key={index}
              className="group relative h-[245px] overflow-hidden rounded-[28px] border border-gray-200 shadow-xl dark:border-white/10 md:h-[280px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="h-full w-full object-cover transition duration-1000 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="mb-2 inline-flex rounded-full bg-blue-600 px-3 py-1 text-[9px] font-black uppercase tracking-[0.2em] text-white">
                  {index === 0 ? "KOMANDA" : "SAĞ + SOL"}
                </div>

                <h3 className="text-2xl font-black uppercase italic text-white">
                  {item.title}
                </h3>

                <p className="mt-2 text-sm text-gray-200">
                  {item.text}
                </p>
              </div>
            </div>
          ))}

          {/* ƏSAS MƏLUMAT */}
          <div className="relative overflow-hidden rounded-[28px] border border-blue-500/20 bg-gradient-to-br from-blue-600 to-blue-800 p-6 text-white shadow-2xl">
            <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl" />

            <div className="relative">
              <div className="mb-5 flex items-center justify-between">
                <span className="text-xs font-black uppercase tracking-[0.2em] text-blue-100">
                  Əsas məlumat
                </span>

                <span className="rounded-full bg-white/15 px-3 py-1 text-[10px] font-bold">
                  ARTİM
                </span>
              </div>

              <div className="grid grid-cols-2 gap-3">
                {/* Tək qol */}
                <div className="rounded-2xl bg-black/15 p-4 backdrop-blur-sm">
                  <div className="text-xl font-black">
                    TƏK QOL
                  </div>

                  <div className="mt-1 text-[10px] uppercase text-blue-100">
                    Bir tərəfdə komanda
                  </div>
                </div>

                {/* Cüt qol */}
                <div className="rounded-2xl bg-black/15 p-4 backdrop-blur-sm">
                  <div className="text-xl font-black">
                    CÜT QOL
                  </div>

                  <div className="mt-1 text-[10px] uppercase text-blue-100">
                    Sağ + sol tərəf
                  </div>
                </div>

                {/* 10 nəfər */}
                <div className="rounded-2xl bg-black/15 p-4 backdrop-blur-sm">
                  <div className="text-xl font-black">
                    10 NƏFƏR
                  </div>

                  <div className="mt-1 text-[10px] uppercase text-blue-100">
                    Tək qol üçün başlanğıc
                  </div>
                </div>

                {/* 6 nəfər */}
                <div className="rounded-2xl bg-black/15 p-4 backdrop-blur-sm">
                  <div className="text-xl font-black">
                    6 NƏFƏR
                  </div>

                  <div className="mt-1 text-[10px] uppercase text-blue-100">
                    Cüt qol üçün başlanğıc
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* AŞAĞI MƏLUMAT KARTLARI */}
      <div className="relative z-10 mx-auto mt-12 grid max-w-7xl grid-cols-1 gap-4 md:grid-cols-3">
        {/* Kart 1 */}
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-white/[0.03]">
          <div className="mb-2 text-xs font-black uppercase tracking-widest text-blue-500">
            01 — Komanda qur
          </div>

          <p className="text-sm leading-6 text-gray-600 dark:text-gray-400">
            Komandanıza yeni insanlar qoşulduqca ümumi nəticəniz artır və
            daha yüksək səviyyələrə doğru irəliləyə bilərsiniz.
          </p>
        </div>

        {/* Kart 2 */}
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-white/[0.03]">
          <div className="mb-2 text-xs font-black uppercase tracking-widest text-blue-500">
            02 — Sağ və sol tərəf
          </div>

          <p className="text-sm leading-6 text-gray-600 dark:text-gray-400">
            Həm sağ, həm də sol tərəfdə komanda yaratmağa çalışın. İki
            tərəfin birlikdə inkişafı cüt qol maaşı üçün əsas şərtlərdən
            biridir.
          </p>
        </div>

        {/* Kart 3 */}
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-white/[0.03]">
          <div className="mb-2 text-xs font-black uppercase tracking-widest text-blue-500">
            03 — Davamlı inkişaf
          </div>

          <p className="text-sm leading-6 text-gray-600 dark:text-gray-400">
            Komandanız böyüdükcə nəticələriniz də artır. Məqsəd yalnız
            komanda yaratmaq deyil, onu davamlı şəkildə inkişaf etdirməkdir.
          </p>
        </div>
      </div>

      {/* SWIPER STİLLƏRİ */}
      <style>{`
        .artim-swiper .swiper-button-next,
        .artim-swiper .swiper-button-prev {
          width: 48px;
          height: 48px;
          border-radius: 999px;
          color: #fff !important;
          background: rgba(37, 99, 235, 0.75);
          border: 1px solid rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .artim-swiper .swiper-button-next:hover,
        .artim-swiper .swiper-button-prev:hover {
          transform: scale(1.08);
          background: rgba(37, 99, 235, 1);
          box-shadow: 0 0 25px rgba(37, 99, 235, 0.5);
        }

        .artim-swiper .swiper-button-next:after,
        .artim-swiper .swiper-button-prev:after {
          font-size: 18px;
          font-weight: 900;
        }

        .artim-swiper .swiper-pagination {
          bottom: 8px !important;
        }

        .artim-swiper .swiper-pagination-bullet {
          width: 7px;
          height: 7px;
          background: rgba(255, 255, 255, 0.5);
          opacity: 1;
          transition: all 0.3s ease;
        }

        .artim-swiper .swiper-pagination-bullet-active {
          width: 28px;
          border-radius: 10px;
          background: #2563eb !important;
        }

        .artim-swiper .swiper-slide {
          transition:
            transform 0.8s ease,
            opacity 0.8s ease;
        }

        @media (max-width: 640px) {
          .artim-swiper .swiper-button-next,
          .artim-swiper .swiper-button-prev {
            width: 40px;
            height: 40px;
          }

          .artim-swiper .swiper-button-next:after,
          .artim-swiper .swiper-button-prev:after {
            font-size: 14px;
          }
        }
      `}</style>
    </section>
  );
};

export default Sec;